import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
    getIdKegiatan,
    getListKegiatan,
} from "../../redux/actions/actionKegiatan";

export default function Kegiatan() {
    const {
        getListKegiatanResult,
        getListKegiatanLoading,
        getListKegiatanError,
    } = useSelector((state) => state.indexReducerKegiatan);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListKegiatan());
    }, [dispatch]);

    const navigate = useNavigate();

    const handleDetail = (idk) => {
        navigate(`/Kegiatan/${idk.judul_kegiatan.replace(/ /g, "-")}`);
        dispatch(getIdKegiatan(idk));
    };
    return (
        <>
            <section className="section" id="kegiatan">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="title-heading mb-5">
                                <h3 className="text-dark mb-1 fw-light text-uppercase">
                                    Kegiatan
                                </h3>
                                <div className="title-border-simple position-relative"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {getListKegiatanResult ? (
                            getListKegiatanResult.map((item, index) => {
                                return (
                                    <div
                                        className=" col-sm-12 col-lg-4"
                                        key={index}
                                    >
                                        <div className="kegiatan-box rounded mt-2 p-3  card2">
                                            <div className="kegiatan-icon mb-2">
                                                {/* <AiOutlineBgColors /> */}
                                            </div>
                                            <div className="kegiatan-desc">
                                                <div className="kegiatan-title mb-2 position-relative">
                                                    <h5 className="fw-normal mb-3">
                                                        <Typography
                                                            className="text-dark cursor-pointer"
                                                            onClick={() => {
                                                                handleDetail(
                                                                    item
                                                                );
                                                            }}
                                                        >
                                                            {
                                                                item.judul_kegiatan
                                                            }
                                                        </Typography>
                                                    </h5>
                                                </div>
                                                <p className="text-muted text-hide mb-3 f-14 ">
                                                    {item.deskripsi}
                                                </p>

                                                <Typography
                                                    className="text-primary mb-0 f-13 cursor-pointer"
                                                    onClick={() => {
                                                        handleDetail(item);
                                                    }}
                                                >
                                                    learn more
                                                </Typography>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : getListKegiatanLoading ? (
                            <>
                                <p> Loading data...</p>
                            </>
                        ) : (
                            <p>
                                {getListKegiatanError
                                    ? getListKegiatanLoading
                                    : "data..."}
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
